import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';

import { buttonCSS } from '@simplywallst/ui-core';

import type { ButtonProps } from '@simplywallst/ui-core';

export const NewScreener = styled(RouterLink)<ButtonProps>`
  ${buttonCSS}
`;

export const SavedScreenerSpinnerContainer = styled.div<{
  isLoading: boolean;
}>`
  opacity: ${({ isLoading }) => (isLoading ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
`;
